import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { OrderTabsComponent } from '@b2b/components/order/order-tabs/order-tabs.component';
import { boletoIcon } from '@b2b/features/cart/helpers/logos';
import { InputFieldComponent } from '@shared/components/form-elements/input-field/input-field.component';
import { OrderItemComponent } from '@b2b/components/order/order-item/order-item.component';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonLoadingComponent } from '@shared/components/skeleton-loading/skeleton-loading.component';
import { OrderService } from '@b2b/features/order/core/order.service';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { distinctUntilChanged, filter, map, skip } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'order-list',
  imports: [
    CommonModule,
    RouterModule,
    OrderTabsComponent,
    InputFieldComponent,
    OrderItemComponent,
    PaginationComponent,
    TranslateModule,
    SkeletonLoadingComponent,
  ],
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
})
export class OrderListComponent implements OnInit {
  orderService = inject(OrderService);
  private cartService = inject(CartService);
  private destroyRef = inject(DestroyRef);

  orders$ = this.orderService.takeOrder();
  isLoading$ = this.orderService.isLoadingOrders();
  currentPage$ = this.orderService.getCurrentPage();
  totalPages$ = this.orderService.getTotalPages();
  activeTab: 'order' | 'invoice' | 'ticket' = 'order';
  tabs = [
    { name: 'Pedidos', active: this.activeTab === 'order', iconName: 'receipt_long' },
    { name: 'Boletos Pendentes', active: this.activeTab === 'ticket', customIconSrc: boletoIcon },
  ];
  constructor() {}

  ngOnInit() {
    this.orderService.loadOrders();

    this.cartService
      .getCart()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(cart => cart.data?.b2BUnitCode),
        filter((code): code is string => !!code),
        distinctUntilChanged(),
        skip(1),
      )
      .subscribe(() => {
        this.orderService.loadOrders();
      });
  }

  goToPage(page: number) {
    this.orderService.loadOrders(page);
  }

  onSelectTab(tab: any) {
    this.activeTab = tab.name === 'Pedidos' ? 'order' : 'ticket';
    this.tabs = this.tabs.map(t => ({ ...t, active: t.name === tab.name }));

    // if (this.activeTab === 'ticket') {
    //   this.orders.pipe(take(1)).subscribe(orders => {
    //     orders.filter(order => order.ICON === 'RJT');
    //   });
    // }
  }
}
